<template>
  <div v-if="this.requireAdmin && !isAdmin">
    <b-alert variant="danger" show>{{$t('needAdministStr')}}</b-alert>
  </div>
  <div v-else-if="this.requireManager && !isManager">
    <b-alert variant="danger" show>{{$t('needAdministStr')}}</b-alert>
  </div>
  <div v-else-if="!getIsAllowedIPAddressForManagement">
    <b-alert variant="danger" show>{{$t('notAllowedIpAddress')}}</b-alert>
  </div>
  <div v-else class="manage-table">
  <slot></slot>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'ManageWrapperComponent',
  props: {
    'requireAdmin': {
      type: Boolean,
      default: false
    },
    'requireManager': {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters('repository/', [
      'getIsAllowedIPAddressForManagement'
    ]),
    ...mapGetters('_meta/', [
      'getMetaIsDeveloper',
      'getMetaIsAdmin',
      'getMetaIsManager'
    ]),
    isAdmin: function () {
      console.log('* Admin:', this.requireAdmin, this.getMetaIsAdmin)
      return this.getMetaIsAdmin
    },
    isManager: function () {
      console.log('* Manager:', this.requireManager, this.getMetaIsManager)
      return this.getMetaIsManager
    }
  },
  methods: {
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Manage/ManageWrapperComponent.vue